import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  ObjectionsModel,
  ObjectionTableModel
} from '../../../../pages/invoicesPage/invoicesPage.Model'
import { GlobalerisClientModel } from '../../../../pages/tasks/tasks.model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumDominioTarea } from '../../../oData/enums/enumDominioTarea'
import {
  AtlasUserModel,
  FilterTaskRequest,
  TaskCommentModel,
  TaskModel,
  TaskModelWithObjections,
  TaskPatchModel,
  TaskPostModel,
  TaskTypeModel
} from './model/tasks'

export const apiGetTaskById = async (taskID: number): Promise<TaskModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks(${taskID})`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetTaskWithObjectionsById = async (
  taskID: number,
  taskDomain: EnumDominioTarea
): Promise<TaskModelWithObjections> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Tasks/GetTasksWithObjections?taskDomain=${taskDomain}&taskId=${taskID}`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetObjectionsByTaskDomain = async (
  taskDomain: EnumDominioTarea
): Promise<ObjectionTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Tasks/GetObjectionsByTaskDomain(${taskDomain})`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetObjectionsFromTaskEntity = async (
  entityId: number,
  taskDomain: EnumDominioTarea
): Promise<ObjectionsModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks/GetObjectionsFromTaskEntity`, {
    params: {
      entityId,
      taskDomain
    }
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetTasks = async (): Promise<TaskModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks/GetTasks`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetTasksExpanded = async (): Promise<TaskModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks/GetTasksExpanded`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetFilteredTasksExpanded = async (
  request: FilterTaskRequest
): Promise<TaskModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Tasks/GetFilteredTasksExpanded`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPostTask = async (request: TaskPostModel): Promise<TaskModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Tasks`, request).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPatchTask = async (taskId: number, request: TaskPatchModel): Promise<TaskModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Tasks(${taskId})`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiGetTaskTypes = async (): Promise<TaskTypeModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks/GetTaskTypes`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

// TASK COMMENTS API //

export const apiGetTaskComment = async (taskId: number): Promise<TaskCommentModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks(${taskId})/Comments`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostTaskComment = async (
  taskId: number,
  request: TaskCommentModel
): Promise<TaskCommentModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Tasks(${taskId})/Comments`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiPatchTaskComment = async (
  taskId: number,
  taskCommentId: number,
  request: TaskCommentModel
): Promise<TaskCommentModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Tasks(${taskId})/Comments(${taskCommentId})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteTaskComment = async (
  taskId: number,
  taskCommentId: number
): Promise<object> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/Tasks(${taskId})/Comments(${taskCommentId})`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiFetchGlobalerisClientFromDomain = async (
  domain: string
): Promise<GlobalerisClientModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Clients/domain/${domain}`).then(
    response => response.data
  )
}

export const apiFetchUsersFromGlobalerisClient = async (clientId: number): Promise<string[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/AdminUsers/users/${clientId}`).then(
    response => response.data
  )
}

export const apiGetMeUsers = async (): Promise<string[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/MeUsers`).then(response => response.data)
}

export const apiGetAtlasUsers = async (): Promise<AtlasUserModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tasks/GetUsuariosAtlas`).then(
    response => response.data
  )
}

// TASK ACTIONS API //

export const apiPostTaskActions = async (
  taskId: number,
  request: any
): Promise<TaskCommentModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Tasks(${taskId})/ExecuteActions`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}
